import { Button, Menu, Popover } from "antd";
import styled from "styled-components";
import { UserOutlined as AntdUserOutlined, BarsOutlined, CloseOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

export const StyledButton = styled(Button)`
  padding: 5px;
  border-radius: 4px;
`;

export const FilterWrapper = styled.div<{ isBoard?: boolean }>`
  display: ${({ isBoard }) => (isBoard ? "none" : "flex")};
  flex-direction: row;
  gap: 20px;
  @media (max-width: 1435px) {
    display: ${({ isBoard }) => (isBoard ? "flex" : "none")};
  }
  @media (max-width: 700px) {
    flex-direction: ${({ isBoard }) => (isBoard ? "column" : "row")};
  }
`;

export const HeaderContainer = styled.header<{
  isBlack: boolean;
  bgColor?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ isBlack, bgColor }) => (isBlack ? "#333333" : bgColor ? bgColor : "#ffffff")};
  padding: 1rem 1rem;
  position: sticky;
  top: 0;
  z-index: 1000;
  width: calc(100% - 2rem);
  height: 50px;
  /* box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); */

  @media (max-width: 992px) {
    padding: 1rem 1rem;
  }
  @media (max-width: 992px) {
    padding: 10px 0 10px 10px;
    width: calc(100% - 10px);
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;
export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px; // Adjust spacing between logos
  height: 100%;

  .logoIcon {
    height: 32px; // Set consistent height
    width: auto; // Maintain aspect ratio
    object-fit: contain;
  }

  .static-logo {
    // Specific styles for static logo if needed
  }

  .dynamic-logo {
    // Specific styles for dynamic logo if needed
  }
`;

export const Divider = styled.span`
  font-size: 30px;
  color: #003b73;
  margin-right: 0.5rem;
`;

export const Logo = styled.div`
  font-size: 30px;
  font-weight: bold;
  color: #003b73;
`;

export const NavLinks = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-right: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: #003b73;
  font-size: 1rem;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const HeaderLeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
`;

export const HeaderRightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LanguageDropdown = styled.div`
  font-size: 1rem;
  color: #003b73;
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    margin-right: 8px;
    font-weight: 500;
  }

  svg {
    font-size: 12px;
  }
`;

export const LogoutText = styled.span`
  margin: 0 20px;
  cursor: pointer;
`;

export const SidebarText = styled.p`
  cursor: pointer;
`;

export const NavContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  @media (max-width: 992px) {
    display: none;
  }
`;

export const WebNavBar = styled(Menu)`
  width: 100%;
  justify-content: flex-end;
  border: none;

  .ant-menu-title-content {
    font-weight: 600;
  }

  .ant-menu-item-selected::after {
    border-bottom: none !important;
  }

  .ant-menu-submenu-open::after {
    border-bottom: none !important;
  }

  .ant-menu-item::after {
    border-bottom: none !important;
  }

  .ant-menu-submenu::after {
    border-bottom: none !important;
  }

  .ant-menu-submenu:hover {
    border-bottom: none !important;
  }

  .ant-menu-submenu-title {
    display: flex;
    flex-direction: row-reverse;
  }

  .ant-menu-title-content {
    margin-left: 0 !important;
  }

  .ant-menu-item-icon {
    margin-left: 0.5rem !important;
  }

  .ant-menu-submenu {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .ant-menu-sub {
    min-width: 71px !important;
    background-color: red !important;
  }

  /* Ensure the dropdown does not get overridden */
  .ant-menu-sub .ant-menu-item {
    white-space: nowrap;
  }
  /* .ant-menu-item-selected {
    background-color: #aab1b529 !important;
  } */
`;

export const UserOutlined = styled(AntdUserOutlined)`
  background-color: #e4e6e7;
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
`;

export const PopoverContainer = styled(Popover)`
  margin: 0 0.8rem;
`;

export const PopoverButton = styled(Button)`
  padding: 0;
  border: 0;
  margin-left: 15px;
`;

export const PopoverMenu = styled.div`
  margin: 0 3rem 0 0;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  gap: 0.5rem;
  cursor: pointer;
`;

export const Hamburger = styled.div`
  display: none;
  margin-left: auto;

  @media (max-width: 992px) {
    display: flex;
    width: fit-content;
    justify-content: flex-end;
  }
`;

export const MobileNavBar = styled(Menu) <{ isOpen: boolean }>`
  position: fixed;
  top: 70px;
  right: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
  z-index: 1000;
  width: 100%;
  max-width: 50%;
  height: calc(100vh - 68px);
  background-color: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  overflow-y: auto;

  .ant-menu-title-content {
    display: block;
    margin-inline-start: 0px !important;
    font-weight: 600;
  }

  .ant-menu-submenu-title .ant-menu-item-icon {
    display: none;
  }

  @media (max-width: 400px) {
    max-width: 100%;
  }

  .ant-menu-sub {
    padding-left: 8px !important;
  }

  .ant-menu-submenu-title {
    padding-left: 18px !important;
  }

  .ant-menu-item {
    padding-left: 18px !important;
  }
`;

export const MobileFoundItem = styled.div`
  display: none;
  margin-right: 10px;
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;

  /* @media (max-width: 430px) {
    display: none;
  } */
`;

export const CloseOutlinedIcon = styled(CloseOutlined)`
  font-size: 30px;
`;

export const BarsOutlinedIcon = styled(BarsOutlined)`
  font-size: 30px;
`;

export const FoundItemButton = styled(Button) <{ color?: string }>`
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background-color: ${(props: { color?: string }) => props.color || "#0d63ff"};
  font-size: 14px;
  height: 40px;

  &:hover {
    background: ${(props: { color?: string }) => props.color || "#2461d1"} !important;
  }

  @media (max-width: 430px) {
    .found-item-text {
      display: none;
    }
  }
`;

export const NewContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const NewProfileIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
`;

export const ProfileDropdownMenu = styled.div`
  position: absolute;
  top: 36px;
  right: 0;
  width: 184px;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding-top: 10px;
  z-index: 1000;
`;

export const MenuItemLabel = styled.div`
  padding: 0px 12px;
  font-size: 10px;
  color: #797f8c;
`;

export const DropdownMenuItem = styled.div<{ isActive: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? "#0d63ff" : "#000")};
  font-weight: ${({ isActive }) => (isActive ? "500" : "500")};

  &:hover {
    background: #f5f5f5;
  }
`;

export const NewDivider = styled.div`
  height: 1px;
  background: #ddd;
  margin-bottom: 5px;
`;

export const NewLogout = styled.div`
  color: #eb4335;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
  }
`;

export const BrandImage = styled.img`
  height: 32px;
  width: auto;
  object-fit: contain;
  align-self: end;
`;

export const SidebarToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  margin-right: 10px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const MenuFoldIcon = styled(MenuFoldOutlined)`
  font-size: 20px;
`;

export const MenuUnfoldIcon = styled(MenuUnfoldOutlined)`
  font-size: 20px;
`;
